import request from "../request"
import qs from "qs";

export function getAlarmDataById(params) {
  return request.get({
    url: "/warning_info/detail",
    params: params
  })
}
export function getAlarmDataOptions() {
    return request.get({
      url: "/warning_info/class"
    })
}
export function getAllResource() {
    return request.get({
      url: "/ground_resource/getAll"
    })
}
export function deleteAlarmData(params) {
    return request.delete({
        url: "/warning_info/del",
        params: params
    })
}
export function getAlarmTableData(params) {
  return request.get({
    url: "/warning_info/page",
    params: params
  })
}

export function auditAlarm(params) {
    return request.put({
        url: '/warning_info/audit', 
        params: params
    })
}



